export const MONTH_OPTIONS = [
    {
        key: 1,
        value: '1 mes'
    },
    {
        key: 3,
        value: '3 meses',
    },
    {
        key: 0,
        value: 'Todos'
    }
];
